import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'fileSize'})

export class FileSizePipe implements PipeTransform {

	constructor() { }

	transform(bytes: number, appendString: string = ''): string {
		let displaySpeed = bytes;
		if (!bytes) {
			return '';
		}
		const units = [
			'B',
			'kB',
			'MB',
			'GB',
			'TB',
			'PB'
		];
		let unitIndex = 0;
		while (displaySpeed >= 1000) {
			unitIndex++;
			displaySpeed = displaySpeed / 1000;
		}
		return displaySpeed.toFixed(2) + ' ' + units[unitIndex] + appendString;
	}
}
